import { gql } from "@apollo/client";

export const UPDATE_TASK_RESULT_MUTATION = gql`
  mutation UpdateTaskResult($id: ID!, $input: UpdateTaskResultInput!) {
    updateTaskResult(id: $id, input: $input) {
      id
      assetId
      obligationResultId
      result
      frequency
      description
      data
      documentId
      documentType
      dueDate
      updatedAt
    }
  }
`;

export const SUGGEST_TASKS_FROM_DOCUMENT_MUTATION = gql`
  mutation SuggestTasksFromDocument($documentId: ID!) {
    suggestTasksFromDocument(documentId: $documentId)
  }
`;

export const VALIDATE_DOCUMENT_PROMPT_MUTATION = gql`
  mutation ValidateDocumentPrompt($input: ValidateDocumentPromptInput!) {
    validateDocumentPrompt(input: $input) {
      valid
      timedOut
      summary
      matches {
        entityType
        label
        name
      }
    }
  }
`;

// ─── Timeline notes (asset + location) ───────────────────────────────────────
// Used by EntityTimelineCard's add-note drawer and inline edit/delete
// affordances. The backend's timeline INSERT/UPDATE/DELETE resolvers all live
// in services/graphql-service/src/resolvers/{asset,location}Timeline.ts.

export const FORMAT_OBLIGATION_FROM_DESCRIPTION = gql`
  mutation FormatObligationFromDescription($description: String!) {
    formatObligationFromDescription(description: $description) {
      obligation
      description
      origins
      type
      standard
      reference
      evidences
      obligationClass
      fulfillmentMode
      consequenceOfBreach
      flags
      triggerType
      cadenceInterval
      cadenceLabel
    }
  }
`;

export const CREATE_OBLIGATION = gql`
  mutation CreateObligation($input: CreateObligationInput!) {
    createObligation(input: $input) {
      obligationId
      obligation
      description
      origins
      type
      standard
      reference
      evidences
      obligationClass
      fulfillmentMode
      consequenceOfBreach
      flags
      locationId
      productTypeId
      productId
      triggerType
      cadenceInterval
      cadenceLabel
      anchorDate
      standardKey
      status
      createdAt
      updatedAt
    }
  }
`;
